// extracted by mini-css-extract-plugin
export var avoid = "form-module--avoid--55681";
export var form = "form-module--form--17749";
export var formButton = "form-module--formButton--e259f";
export var formInput = "form-module--formInput--4980e";
export var iconWrapper = "form-module--iconWrapper--20e1d";
export var inputContainer = "form-module--inputContainer--2456d";
export var inputLabel = "form-module--inputLabel--7b57e";
export var onFooter = "form-module--onFooter--7a8d4";
export var successWrapper = "form-module--successWrapper--b56f8";